import { Button } from "baseui/button";
import { Checkbox } from "baseui/checkbox";
import { Input } from "baseui/input";
import { Select } from "baseui/select";
import { useState } from "react";
import { FormattedMessage } from 'react-intl';
import { HorizontalStackPanel } from "../../../../components/Layout/StackPanel";
import { DeleteAlt } from "baseui/icon";

export interface ValueCellSelectorProps {
    dataType: string,
    value: any,
    onValueChanged: (value: boolean | number | null) => void
    onValueBlur?: (value: boolean | number | null) => void
    valueOptions?: TValueOption[] | undefined // if value is an enum - provide possible values here
}

export type TValueOption = {
    label: string,
    value: number
}

export const ValueCellSelector = (props: ValueCellSelectorProps) => {

    if (props.dataType === 'System.Boolean') {
        return <BooleanCell {...props}></BooleanCell>
    }
    if (props.dataType === 'System.UInt32' && props.valueOptions) {
        return <SelectionCell {...props} valueOptions={props.valueOptions}></SelectionCell>
    }
    if (props.dataType === 'System.Double' || props.dataType === 'System.Single') {
        return <DoubleCell {...props}></DoubleCell>
    }
    return <NumericCell  {...props} />
}



const BooleanCell: React.FC<ValueCellSelectorProps> = (props) => {
    const onValueChange = (e: any) => {
        props.onValueChanged(e.target.checked);
    }
    const onValueBlur = (e: any) => {
        if (props.onValueBlur) {
            if (isInputArgsEmpty(e))
                props.onValueBlur(null);
            else
                props.onValueBlur(Number(e.target.value));
        }
    }
    const onClear = (e: any) => {
        props.onValueChanged(null);
    }
    const bValue = props.value === null ? false : props.value;
    return (
        <HorizontalStackPanel $alignItems={'center'}>
            <Checkbox onBlur={onValueBlur} labelPlacement='right' checked={bValue} isIndeterminate={props.value === null} onChange={onValueChange}>{bValue ? <><FormattedMessage id="on" defaultMessage="ON" /></> : <><FormattedMessage id="off" defaultMessage="OFF" /></>}</Checkbox>
            {props.value !== null && <Button kind="tertiary" size='mini' shape="circle" onClick={onClear}><DeleteAlt /></Button>}

        </HorizontalStackPanel>

    );
}

const DoubleCell: React.FC<ValueCellSelectorProps> = (props) => {
    const onValueChange = (e: any) => {
        if (isInputArgsEmpty(e))
            props.onValueChanged(null);
        else
            props.onValueChanged(Number(e.target.value));
    }
    const onValueBlur = (e: any) => {
        if (props.onValueBlur) {
            if (isInputArgsEmpty(e))
                props.onValueBlur(null);
            else
                props.onValueBlur(Number(e.target.value));
        }
    }
    return (
        <Input autoFocus={false} onBlur={onValueBlur} clearable type='number' value={props.value} onChange={onValueChange}></Input>
    );
};



const NumericCell: React.FC<ValueCellSelectorProps> = (props) => {

    const onValueChange = (e: any) => {
        if (isInputArgsEmpty(e))
            props.onValueChanged(null);
        else
            props.onValueChanged(Number(e.target.value));
    }
    const onValueBlur = (e: any) => {
        if (props.onValueBlur) {
            if (isInputArgsEmpty(e))
                props.onValueBlur(null);
            else
                props.onValueBlur(Number(e.target.value));
        }
    }

    return (
        <Input autoFocus={false} onBlur={onValueBlur}  clearable type='number' value={props.value} onChange={onValueChange}></Input>
    );
}

const SelectionCell: React.FC<ValueCellSelectorProps> = (props) => {
    const { onValueChanged } = props;
    const valueOptions = props.valueOptions ?? []
    const selectedOption = valueOptions.find(v => v.value === props.value);
    const [value, setValue] = useState<any[]>(selectedOption ? [selectedOption] : []);


    const onValueChange = (e: any) => {
        setValue(e.value);
        if (isSelectArgsEmpty(e))
            onValueChanged(null);
        else if (e.value.length > 0)
            onValueChanged(e.value[0].id);
    }

    return (
        <Select
            options={valueOptions.map((v) => ({ label: v.label, id: v.value }))}
            multi={false}
            value={value}
            clearable
            searchable={false}
            placeholder="Select a value"
            onChange={onValueChange}
        />
    );
}

const isInputArgsEmpty = (e: any) => {
    return e.target.value === null || e.target.value === undefined || e.target.value === "";
}

const isSelectArgsEmpty = (e: any) => {
    return e.value === null || e.value.length === 0;
}